export default {
  title: 'Rabatkode',
  fields: {
    preset: {
      label: 'Skabelon',
    },
    presets: {
      master: 'Master',
      campaign: 'Kampagne',
      one_time: 'Engangs',
    },
    code: {
      label: 'Kode',
      placeholder: 'Angiv kode',
    },
    discount_type: {
      label: 'Rabattype',
    },
    quantity: {
      label: 'Antal',
      placeholder: 'Ubegrænset',
    },
    expires_at: {
      label: 'Udløbsdato',
      placeholder: 'Angiv dato eller lad feltet stå tomt',
    },
    franchise: {
      label: 'Masterrabatkode for restauranten og/eller på tværs af brandet',
    },
    discount: {
      label: 'Rabat',
    },
    usage_threshold: {
      label: 'Brugsgrænse',
    },
  },
  messages: {
    master_warning: 'Oprettelse af en ny "master"-rabatkode udløber den nuværende masterrabatkode',
  },
  buttons: {
    save: 'Gem',
    cancel: 'Annuller',
  },
  toasts: {
    promo_code_got_created: 'Rabatkoden blev oprettet',
    promo_code_got_updated: 'Rabatkoden blev opdateret',
  },
};
